import React, { useState } from 'react';
import clsx from 'clsx';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';


import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import MoreIcon from '@material-ui/icons/MoreVert';

import MenuMobile from './MenuMobile';
import MenuDesktop from './MenuDesktop';
import useStyles from './UseStyle';
import ListMenuItem from '../Menu/ListMenuItem';
import { useDispatch } from 'react-redux';
import { logout } from '../../../user/domain/userSlice';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Box, useTheme } from '@material-ui/core';
import { Copyright } from '../UI/CopyRight';




function Header({ title, _menus }) {
    const classes = useStyles();
    const history = useHistory();
    const [open, setOpen] = useState(true);
    const [anchorEl, setAnchorEl] = useState(null);
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
    const [numNotifications] = useState(0);

    const isMenuOpen = Boolean(anchorEl);
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

    const dispatch = useDispatch();

    //Eventos de open y close menu
    const handleDrawerOpen = () => {
        setOpen(true);
    };
    const handleDrawerClose = () => {
        setOpen(false);
    };

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        handleMobileMenuClose();
    };

    const handleLogout = () => {
        handleMenuClose();
        dispatch(logout());
    }

    const goProfileUser = () => {
        history.push('/users/profile')
    }

    const handleMobileMenuOpen = (event) => {
        setMobileMoreAnchorEl(event.currentTarget);
    };
    const theme = useTheme(); // Obtén el tema

    const primaryColor = theme.palette.primary.main;
    const menuId = 'primary-search-account-menu';
    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            id={menuId}
            keepMounted
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem onClick={goProfileUser}>Profile</MenuItem>
            <hr />
            <MenuItem onClick={handleLogout}>Salir</MenuItem>
        </Menu>
    );

    const MobileMenuId = 'primary-search-account-menu-mobile';

    return (
        <>
            <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)} style={{color:'#EFF1F3'}}>
                <Toolbar className={classes.toolbar} style={{color:primaryColor}}>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
                        
                    >
                        <MenuIcon style={{color:primaryColor}}/>
                    </IconButton>
                    <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                        <img

                            src='https://orus-centraldevida.s3.amazonaws.com/Logos/EVBI+-+Logo__1+(1).png' width="200" alt="Logo" />
                        {!open}
                    </Typography>
                    <div className={classes.sectionDesktop}>
                        <MenuDesktop width="60"
                            menuId={menuId}
                            handleProfileMenuOpen={handleProfileMenuOpen}
                            numNotifications={numNotifications}
                            style={{color:primaryColor}}
                        />
                    </div>
                    <div className={classes.sectionMobile}>
                        <IconButton
                            aria-label="show more"
                            aria-controls={MobileMenuId}
                            aria-haspopup="true"
                            onClick={handleMobileMenuOpen}
                            style={{color:primaryColor}}
                        >
                            <MoreIcon />
                        </IconButton>
                    </div>
                </Toolbar>
            </AppBar>
            <MenuMobile width="60"
                handleProfileMenuOpen={handleProfileMenuOpen}
                isMobileMenuOpen={isMobileMenuOpen}
                handleMobileMenuClose={handleMobileMenuClose}
                mobileMoreAnchorEl={mobileMoreAnchorEl}
                MobileMenuId={MobileMenuId}
                numNotifications={numNotifications}
                style={{color:primaryColor}}
            />
            {/* aqui inicia la lista del menujson */}
            {renderMenu}
            <Drawer width="200"
                variant="permanent"
                classes={{
                    paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
                }}
                open={open}
             color='primary'

            >
                <div className={classes.toolbarIcon}>
                    <Typography component="h1" variant="h6" color='primary' noWrap >


                    </Typography>
                    <IconButton onClick={handleDrawerClose}>
                        <ChevronLeftIcon  style={{color:primaryColor}}/>
                    </IconButton>
                </div>
                <Divider />
                <Box>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>

                </Box>

                <ListMenuItem _menus={_menus} />
                {/* <Divider />
                <List>{mainListItems}</List>
                <Divider />
                <List>{secondaryListItems}</List> */}
                <Box pt={3} className={classes.copyrightBottom} >
                    {open ? <Copyright /> :
                        <Typography variant="body2" color="#0088FE" align="center">
                            <b>{`${process.env.REACT_APP_VERSION}`}</b>
                        </Typography>}
                </Box>
            </Drawer>
        </>
    );
}

export default Header;